module.exports = __webpack_public_path__ + "img/special-photo-03.ed22715e.jpg";